import { createContext, useCallback, useContext, useRef, useState } from 'react';

const UiContext = createContext(null);

let toastId = 0;

export function UiProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const [confirmState, setConfirmState] = useState(null);
  const resolverRef = useRef(null);

  const showToast = useCallback((message, type = 'info') => {
    const id = ++toastId;
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 3000);
  }, []);

  const confirmAction = useCallback((title, message) => {
    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setConfirmState({ title, message });
    });
  }, []);

  const handleConfirm = () => {
    setConfirmState(null);
    resolverRef.current?.(true);
  };

  const handleCancel = () => {
    setConfirmState(null);
    resolverRef.current?.(false);
  };

  return (
    <UiContext.Provider value={{ showToast, confirmAction }}>
      {children}

      <div className="toast-container">
        {toasts.map((t) => {
          const icons = { success: '✓', error: '✕', info: '●' };
          return (
            <div key={t.id} className={`toast ${t.type}`}>
              <span>{icons[t.type] || '●'}</span>
              <span>{t.message}</span>
            </div>
          );
        })}
      </div>

      <div className={`modal-overlay${confirmState ? ' open' : ''}`}>
        {confirmState && (
          <div className="confirm-dialog">
            <div className="confirm-icon">!</div>
            <h3>{confirmState.title}</h3>
            <p>{confirmState.message}</p>
            <div className="confirm-actions">
              <button className="btn btn-ghost" onClick={handleCancel}>Cancel</button>
              <button className="btn btn-danger" onClick={handleConfirm}>Delete</button>
            </div>
          </div>
        )}
      </div>
    </UiContext.Provider>
  );
}

export function useUi() {
  const ctx = useContext(UiContext);
  if (!ctx) throw new Error('useUi must be used within UiProvider');
  return ctx;
}
